/**
 * Module dependencies.
 */

import { Service } from 'src/types/service';
import { axiosInstance, getApiEndpoint } from 'src/core/requests';
import { snakeCaseObjectKeys } from 'src/core/utils/objects';
import omit from 'lodash/omit';

/**
 * Export `AppointmentFormData` type.
 */

export type AppointmentFormData = {
  date: string;
  dateOfBirth: string;
  email: string;
  gender: string;
  name: string;
  observations: string;
  phone: string;
  preconditions: string;
  promoCode?: string;
  recaptchaToken: string;
  serviceCategory: Service['category'];
  serviceId: string;
  serviceSubCategory: Service['subCategory'];
  staffMemberId: string;
  subscribeToNewsletter: boolean;
  time: string;
};

/**
 * Export `postAppointment` request.
 */

export async function postAppointment(data: AppointmentFormData) {
  const response = await axiosInstance.post(
    getApiEndpoint('appointment'),
    snakeCaseObjectKeys(omit(data, 'privacyPolicy'))
  );

  return response?.data?.data;
}
